
import { Component, Vue, Prop } from 'vue-property-decorator';

import { namespace } from "vuex-class";
import "@/store/modules/application";
const applicationState = namespace("Application");

import Tooltip from "@/components/survey/Tooltip.vue";
import PageBase from "../PageBase.vue";
import { toggleSteps } from '@/components/utils/TogglePages';

import { stepInfoType, stepResultInfoType } from "@/types/Application";
import {stepsAndPagesNumberInfoType} from "@/types/Application/StepsAndPages";

@Component({
    components:{
        PageBase,
        Tooltip
    }
})
export default class FlmInfo extends Vue {
    
    @Prop({required: true})
    step!: stepInfoType;

    @applicationState.State
    public steps!: stepInfoType[];

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;    

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void

    currentStep = 0;
    currentPage = 0;

    preparationInfo = false;
    thankYouMessage = false;
    disableNextButton = false;
    dataReady = false;
  
    selectedOption = '';
    selected = [];
    selectedReplyForms = [];

    outOfCourtProcessState = false;
    courtProcessState = false;
    
    created() {
        this.disableNextButton = true;       
    }

    mounted(){   
        this.dataReady = false;    
        this.preparationInfo = false; 
        this.thankYouMessage = false;
        this.reloadPageInformation();
    }

    public reloadPageInformation() {   
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;

        const includesOrderActivities = this.steps[this.stPgNo.GETSTART._StepNo].result?.selectedActivity.includes('applyForOrder');
        const includesReplyActivities = this.steps[this.stPgNo.GETSTART._StepNo].result?.selectedActivity.includes('replyToApplication');

        if (includesOrderActivities && this.steps[this.stPgNo.GETSTART._StepNo].result?.selectedForms) {
            this.selected = this.steps[this.stPgNo.GETSTART._StepNo].result.selectedForms;
        }

        if (includesReplyActivities && this.steps[this.stPgNo.GETSTART._StepNo].result?.selectedReplyForms) {
            this.selectedReplyForms = this.steps[this.stPgNo.GETSTART._StepNo].result.selectedReplyForms;
        }
        
        if (this.steps[0].result?.selectedFlmOption) {
            this.selectedOption = this.steps[0].result.selectedFlmOption;

            if (this.selectedOption == 'outOfCourtProcess'){
                this.outOfCourtProcessState = true;
            } else if (this.selectedOption == 'courtProcess'){
                this.courtProcessState = true;
            }
            this.determineSteps();
        }
        
        this.disableNextButton = !(this.selectedOption.length > 0);        

        const progress = this.selectedOption.length==0? 50 : 100;
                
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, false);
        this.dataReady = true;
    }

    public continueOutsideCourtProcess(){
        this.selectedOption = '';
        this.courtProcessState = !this.outOfCourtProcessState;
        this.thankYouMessage = true;

        this.setSelectedOption();      
    }  

    public continueCourtProcess(){
                
        this.outOfCourtProcessState = !this.courtProcessState;

        this.setSelectedOption();        
    }

    public setSelectedOption(){

        this.selectedOption = '';
        if (this.courtProcessState){
            this.selectedOption = 'courtProcess';
        } else {
            this.selectedOption = 'outOfCourtProcess';
        }    
        this.determineSteps();    
    }

    public determineSteps(){
        const wrIncluded = this.selectedReplyForms.includes("writtenResponse");
        const rflmIncluded = this.selectedReplyForms.includes("replyFlm");

        const flmRelatedSteps = [this.stPgNo.FLM._StepNo];

        if (!wrIncluded && !rflmIncluded && this.selected.length < 2){
            flmRelatedSteps.push(this.stPgNo.COMMON._StepNo);
            flmRelatedSteps.push(this.stPgNo.SUBMIT._StepNo)
        }

        toggleSteps(flmRelatedSteps, this.selectedOption == 'courtProcess');
        this.disableNextButton = !this.courtProcessState && !this.outOfCourtProcessState;

    }

    public onPrev() {
        Vue.prototype.$UpdateGotoPrevStepPage();
    }

    public onNext() {
        if (this.selectedOption == 'courtProcess'){
            this.preparationInfo = true;
        } else {
            Vue.prototype.$UpdateGotoNextStepPage();
        }          
    }

    public closePreparationInfo(){
        this.preparationInfo = false;
        Vue.prototype.$UpdateGotoNextStepPage();
    }

    public closeThankYouMessage(){
        this.thankYouMessage = false;        
    }
  
    beforeDestroy() {
        const progress = this.selectedOption.length==0? 50 : 100;
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, true);
        this.UpdateStepResultData({step:this.step, data: {selectedFlmOption: this.selectedOption}});
    }
}
